// src/pages/ProfileGate/OnboardingVisuals.jsx

import React from "react";
import ProfileGateShell from "../../components/profile-gate/ProfileGateShell";

export const ONBOARDING_PENGUINS = {
  book:
    "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/MVP4/Onboarding/Gwin_Book.png",

  table:
    "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/MVP4/Onboarding/Gwin_Table.png",
};

export function OnboardingSpeech({
  children,
  imageClassName = "",
  showPenguin = false,
  penguinUrl = ONBOARDING_PENGUINS.book,
}) {
  return (
    <div
      className={[
        "mx-auto flex w-full min-w-0 max-w-[560px] items-center",
        showPenguin ? "gap-2 sm:gap-4" : ""
      ].join(" ")}
    >
      {showPenguin && (
        <div className="flex w-[28%] max-w-[118px] shrink-0 items-center justify-center">
          <img
            src={penguinUrl}
            alt=""
            aria-hidden="true"
            className={[
              "h-auto w-full object-contain",
              imageClassName,
            ].join(" ")}
            loading="eager"
            decoding="async"
            draggable="false"
          />
        </div>
      )}

      <div
        className="
  flex
  min-h-[80px]
  min-w-0
  flex-1
  items-center
  rounded-[18px]
  border
  border-[#D9D9D9]
  bg-white
  px-3
  py-3
  shadow-[0_1px_2px_rgba(0,0,0,0.03)]
  sm:min-h-[108px]
  sm:rounded-[22px]
  sm:px-6
  sm:py-4
"
      >
        <div className="w-full">
          {children}
        </div>
      </div>
    </div>
  );
}

export function OnboardingFormCard({
  children,
  className = "",
}) {
  return (
    <div
      className={[
        "w-full",
        "rounded-[20px]",
        "border",
        "border-[#E1E1E1]",
        "bg-white",
        "p-4",
        "sm:p-6",
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
}

export function OnboardingInterstitial({
  message,
  secondaryMessage = "",
  onBack,
  onNext,
  showBack = true,
  nextLabel = "Next →",
  nextDisabled = false,
  showSpeechPenguin = false,
  speechPenguinUrl = ONBOARDING_PENGUINS.book,
  speechPenguinClassName = "",
  children = null,
}) {
  return (
    <ProfileGateShell
      title=""
      subtitle=""
      progress={null}
      progressPercent={null}
      showBack={showBack}
      onBack={onBack}
      onNext={onNext}
      backLabel="← Back"
      nextLabel={nextLabel}
      nextDisabled={nextDisabled}
    >
      <div
  className="
    mx-auto
    flex
    w-full
    max-w-[560px]
    min-w-0
    flex-col
    justify-start
    py-4
    sm:py-6
  "
>
        <OnboardingSpeech
          showPenguin={showSpeechPenguin}
          penguinUrl={speechPenguinUrl}
          imageClassName={speechPenguinClassName}
        >
          <div>
            <p
              className="
                text-[17px]
                font-medium
                leading-[1.22]
                tracking-[-0.025em]
                text-[#111111]

                min-[375px]:text-[18px]
                sm:text-[20px]
              "
            >
              {message}
            </p>

            {secondaryMessage ? (
              <p
                className="
                  mt-3
                  text-[14px]
                  font-normal
                  leading-[1.45]
                  text-[#757575]

                  min-[375px]:text-[15px]
                  sm:text-[16px]
                "
              >
                {secondaryMessage}
              </p>
            ) : null}
          </div>
        </OnboardingSpeech>

        {children}
      </div>
    </ProfileGateShell>
  );
}